import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Folder } from 'src/app/models/folder';

@Component({
    selector: 'app-create-folder-modal',
    templateUrl: './create-folder-modal.component.html',
    styleUrl: './create-folder-modal.component.scss',
    imports: [FormsModule, ReactiveFormsModule]
})
export class CreateFolderModalComponent {
  @Input() parentFolder!: Folder;
  @Input() currentPath: Folder[] = [];
  
  folderForm: FormGroup;
  
  constructor(
    public modal: NgbActiveModal,
    private fb: FormBuilder
  ) {
    this.folderForm = this.fb.group({
      name: ['', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_ ]*$/), // Only alphanumeric, spaces and underscore
        Validators.minLength(1),
        Validators.maxLength(50)
      ]]
    });
  }

  onSubmit() {
    if (this.folderForm.valid) {
      this.modal.close(this.folderForm.value);
    }
  }

  get name() {
    return this.folderForm.get('name');
  }

  getFullPath(): string {
    const path = this.currentPath.map(f => f.name).join(' / ');
    return path ? `Root / ${path}` : 'Root';
  }
}
